module.exports = function(service) {
	'use strict'
	service.factory('highlightWords',highlightWords);
	highlightWords.$inject=[];
	function highlightWords() {
		return  function(text,words) {
            words.forEach(function(word) {
                var pattern = new RegExp('(?<![ČĆĐŠŽčćđšž\\w])('+word+')(?![ČĆĐŠŽčćđšž\\w])', 'gi');
                text = text.replace(pattern, '<mark>$1</mark>');
            });
            return text;
        }
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/servicesModule/services/highlightWordsService.js
// module id = 609
// module chunks = 0